import { z } from 'zod';
import i18n from '@/i18n';

export const registrationStepFirstSchema = z.object({
    public_name: z
        .string()
        .trim()
        // @ts-ignore
        .min(1, i18n.t('name_required'))
        // @ts-ignore
        .max(100, i18n.t('name_too_long'))
        // @ts-ignore
        .regex(/^[^\p{Emoji}\p{Emoji_Component}]+$/u, i18n.t('emoji_not_allowed'))
        // @ts-ignore
        .regex(/^[\p{L}\s]+$/u, i18n.t('only_letters_and_spaces_are_allowed'))
        .refine((val) => val.trim().length > 0, {
            // @ts-ignore
            message: i18n.t('name_can_not_consist_only_of_spaces'),
        }),
    about_me: z
        .string()
        .trim()
        // @ts-ignore
        .min(1, i18n.t('desc_required'))
        // @ts-ignore
        .max(255, i18n.t('desc_max_len', { len: 255 })),
    //region: z.object({ label: z.string(), value: z.number() }).nullable(),
    regions: z.array(z.object({ label: z.string(), value: z.number() })).nullable(),
    // @ts-ignore
    gender: z.enum(['male', 'female'], { message: i18n.t('gender_required') }).optional(),
    // @ts-ignore
    dob: z.string().min(1, { message: i18n.t('dob_required') }),
    // @ts-ignore
    travel_plans: z.string().min(1, i18n.t('field_must_not_be_empty')).max(500, i18n.t('desc_too_long')),
});

export type RegistrationStepFirstType = z.infer<typeof registrationStepFirstSchema>;
